import { makeStyles } from '@material-ui/styles'
import { amber } from '@material-ui/core/colors'

export default makeStyles(theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    reportsNavbarContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: theme.spacing(2),
        marginTop: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    button: {
        margin: theme.spacing(1),
    },
    warningButton: {
        backgroundColor: amber[700],
    },
    hidden: {
        display: 'none',
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        margin: 'auto',
        width: 'fit-content',
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 200,
    },
    dataFieldformControl: {
        width: 200,
        margin: 8,
        right: '0px !important',
        position: 'absolute',
        marginRight: '2%',
        marginTop: '-15px !important'
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    boldtext: {
        fontWeight: 'bold',
    },
    selectedReport: {
        backgroundColor: '#0088FE',
        color: 'white',
        "&:hover": {
            backgroundColor: '#0088FE',
        },
    },
}))
